module.exports = {"paymentTypeLabel":"tipo de pagamento","creditLabel":"Crédito","cardLabel":"Cartão","confirmBtn":"Confirmar a alteração?","editDataBtn":"Editar dados"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/EditPaymentInfoCard/data.json
// module id = 2203
// module chunks = 0